import { useContext } from 'react'
import Homepage from '../HomePage/HomePage.jsx';
import HotelReview from '../HotelReview/hotelReview.jsx'
import Login from '../LogInSignUp/loginSignup';
import Header from '../components/header/Header';
import MyReviewsPage from '../MyReviewsPage/MyReviewsPage.jsx';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Account from '../AccountPage/account.jsx';
import Support from '../Support Page/Support.jsx';
import StateAndCity from '../States/State.jsx';
import { UserDataContext } from '../Context/Context.jsx';
import Loading from '../components/Loading/Loading.jsx';
import NotFoundPage from '../NotFoundPage/NotFoundPage.jsx';
import AboutPage from '../AboutPage/AboutPage.jsx';
import PrivacyPolicyPage from '../PrivacyPolicyPage/PrivacyPolicyPage.jsx';
import TermsPage from '../TermsPage/TermsPage.jsx';
import PrivacyDashboard from '../PrivacyDashboard/PrivacyDashboard.jsx';

const AppRoutes = () => {
  const { user, loading } = useContext(UserDataContext);
  const location = useLocation();
  let isLoggedIn = user.loggined
  return (
    !loading ? <>
      {location.pathname !== '/user' && <Header />}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/user" element={<Login />} />
        <Route path="/hotelreview" element={<HotelReview />} />
        <Route path="/myReviews" element={isLoggedIn ? <MyReviewsPage /> : <Navigate to="/user" replace />} />
        <Route path="/account" element={isLoggedIn ? <Account /> : <Navigate to="/user" replace />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/privacy-dashboard" element={isLoggedIn ? <PrivacyDashboard /> : <Navigate to="/user" replace />} />
        <Route path="/support" element={<Support />} />
        <Route path="/state" element={<StateAndCity />} />
        <Route path="/city" element={<StateAndCity />} />
        <Route path="/hotels/search" element={<Navigate to={`/city${location.search}`} replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </> : <Loading />
  );
};
export default AppRoutes;
